import { z } from 'zod'
import { oc } from '@orpc/contract'

export const getScribeGenerationStatusResponseSchema = z.object({
  generating: z.boolean(),
})
export type GetScribeGenerationStatusResponse = z.infer<
  typeof getScribeGenerationStatusResponseSchema
>

export const scribeGenerationStatus = oc
  .route({ method: 'GET', path: '/v2/scribe/sessions/{encounterId}/generation' })
  .input(z.object({ encounterId: z.string() }))
  .output(getScribeGenerationStatusResponseSchema)
